import '@/scss/taxonomy/product-tag/product-tag.scss';
import {loadMore} from "@/js/taxonomy/product-tag/components/loadMore";

loadMore();